import {useQuery} from "@apollo/client";
import {Navigate, useParams} from "react-router";

import ContentContainer from "@/components/layout/ContentContainer.tsx";
import {ErrorFallback} from "@/lib/handlers/ErrorFallback.tsx";
import {UpErrorBoundary} from "@/lib/handlers/UpErrorBoundary.tsx";
import {DashboardDefinitionResult, GQL_DASHBOARD_DEFINITION} from "@/lib/queries/website.ts";
import {DashboardDisplay} from "@/pages/dashboard/display/DashboardDisplay.tsx";
import {setDashboardPosition} from "@/pages/dashboard/display/dashboardUtils.ts";

export const DashboardPage = () => {
  const {id} = useParams();
  const dashboard_id = parseInt(id!);

  const {data, error} = useQuery<DashboardDefinitionResult>(GQL_DASHBOARD_DEFINITION, {
    variables: {
      id: dashboard_id,
    },
  });

  if (error) return <Navigate to="/dashboard/" />;

  if (!data) return null;

  const dashboardDef = setDashboardPosition(data.dashboardDef, data.dashboardDefs);

  return (
    <UpErrorBoundary
      fallback={
        <ContentContainer title={dashboardDef.name}>
          <ErrorFallback />
        </ContentContainer>
      }
    >
      <DashboardDisplay
        dashboardDef={dashboardDef}
        key={`${dashboardDef.id}-${dashboardDef.dashboard_position}-${dashboardDef.ordering}`}
      />
    </UpErrorBoundary>
  );
};
